import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	ModalFooter,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

const EditCertificationDataGuideForm = ({ dataGuide, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, handlerUpdateGuide }) => {

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: false,
		initialValues: {
			kilograms_certified: (dataGuide?.kilograms_certified ? dataGuide.kilograms_certified : dataGuide?.kilograms_received) || ''
		},
		validationSchema: Yup.object({
		}),
		onSubmit: (values) => {
			handlerUpdateGuide({ ...dataGuide, kilograms_certified: values.kilograms_certified });
			handleToggleModal();
		},
	});


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>

			<ModalBody className='modal-body'>
				<TabContent activeTab={'1'}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={12}>
								<Label for='kilograms_certified' className='form-label'>
									Kilogramos certificados
								</Label>
								<Input
									name='kilograms_certified'
									id='kilograms_certified'
									className='form-control'
									placeholder='Ingrese un código'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.kilograms_certified || ''}
									invalid={
										validation.touched.kilograms_certified &&
											validation.errors.kilograms_certified
											? true
											: false
									}
								/>
								{
									validation.touched.kilograms_certified &&
										validation.errors.kilograms_certified ? (
										<FormFeedback type='invalid'>
											{validation.errors.kilograms_certified}
										</FormFeedback>
									) : null
								}
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<ModalFooter>
				<div className='hstack gap-2 justify-content-end'>
					<Button type='button' onClick={() => { handleToggleModal(); }} className='btn-danger btn-label'><i className="icon-x label-icon"></i> Cancelar</Button>
					<button type='submit' className='btn btn-label btn-primary'><i className='ri-save-3-line label-icon'></i> Guardar</button>
				</div>
			</ModalFooter>
		</Form>
	);
};

export default EditCertificationDataGuideForm;